import EditBlackListModal from './EditBlackListModal';

export default EditBlackListModal;
